import { createContext } from 'react'
import { CadExContextReturn } from '../types'

export const CadExContext = createContext<CadExContextReturn>({})
